import * as Yup from "yup";

import type { ShippingMethodOption } from "../shipping-methods";

export const getShippingInfoValidationSchema = (
  shippingMethods: readonly ShippingMethodOption[]
) =>
  Yup.object().shape({
    shipping_method_slug: Yup.string()
      .required("Shipping method is required")
      .oneOf(
        shippingMethods.map(({ slug }) => slug),
        "Shipping method is not available for this environment"
      ),
    shipping_address_company: Yup.string().required("Company is required"),
    shipping_address_property: Yup.string().required("Property is required"),
    shipping_address_line1: Yup.string().required("Address is required"),
    shipping_address_city: Yup.string().required("City is required"),
    shipping_address_state: Yup.string().required("State is required"),
    shipping_address_zip: Yup.string()
      .required("Zip code is required")
      .min(5, "Zip code must be at least 5 characters"),
    shipping_address_contact_name: Yup.string().required(
      "Contact name is required"
    ),
    shipping_address_contact_phone: Yup.string().required(
      "Contact phone is required"
    ),
    shipping_address_contact_email: Yup.string()
      .email("Must be a valid email")
      .required("Contact email is required"),
  });
